module.exports = __webpack_public_path__ + "static/media/DesignSmartSlide02.33b1b926.jpg";